import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import type { TListDataBlock } from 'app/KinerjaKSPage/components/CardDataConfirmation/utils/types'
import type { FC } from 'react'

type Props = Partial<TListDataBlock> & {
  children: React.ReactNode
}

export const DetailContent: FC<Props> = ({
  icon,
  title,
  description,
  children,
}) => {
  return (
    <div className="flex gap-3 rounded px-3 py-4 max-w-4xl">
      <Icon>{icon}</Icon>
      <div className="space-y-4">
        <div className="space-y-1">
          <Text variant="heading-md">{title}</Text>
          <Text variant="body">{description}</Text>
        </div>
        {children}
      </div>
    </div>
  )
}
